//#region src/generated/locales/be.ts
var templates = {};
//#endregion
export { templates };
